<div class="video-record" [class.video-recorded]="recordDataUrl">
  <ng-container>
    @if (recordDataUrl) {
      <lib-video [src]="recordDataUrl" (videoDurationInitialized)="videoDurationInitialized($event)"></lib-video>
    }
  </ng-container>

  <div class="video-wrapper" [class.invisible]="!deviceReady" [class.d-none]="previewMode">
    <video #videoElement class="video-js vjs-default-skin" playsinline></video>
    @if (timestamp < 0) {
      <div class="video-record__counter">
        <span class="video-record__counter-msg">{{'MANUAL_ASSIGNMENT.recording_starts_in' | translate}}</span>
        <div class="video-record__counter-time">
          <span class="video-record__counter-time-value">{{-timestamp}}</span>
        </div>
      </div>
    }
  </div>

  @if (previewMode) {
    <div class="preview-placeholder">
      <mat-icon class="primary-color">camera_alt</mat-icon>
    </div>
  }

  <div class="d-flex flex-wrap align-items-center justify-content-center video-record__controls">
    @switch (status) {
      @case (statuses.INIT) {
        <div class="video-record__status">
          <div class="video-record__status-icon"></div>
          <span class="video-record__status-title">{{'MANUAL_ASSIGNMENT.start_recording' | translate}}</span>
          <span class="video-record__status-time">{{timestamp | secondsToTime}}</span>
        </div>
        <button color="primary" class="video-record__start-btn" mat-fab aria-label="Start video recording" (click)="startRecording()" [disabled]="!deviceReady && recordType !== 'screen'">
          <mat-icon>circle</mat-icon>
        </button>
        @if (canUpload) {
          <input #fileInput type="file" class="d-none" (change)="fileUploaded($event)" accept="video/mp4,video/x-m4v,video/*">
          <button class="video-record__black-btn" mat-fab aria-label="Upload video" (click)="fileInput.click()">
            <mat-icon svgIcon="lms-upload-file"></mat-icon>
          </button>
        }
      }
      @case (statuses.RECORDING) {
        <div class="video-record__status recording">
          <div class="video-record__status-icon">
            @if (timestamp >= 0) {
              <mat-progress-spinner
                class="primary-progress-spinner"
                diameter="26"
                [value]="progress">
              </mat-progress-spinner>
            }
          </div>
          <span class="video-record__status-title">
            {{ (timestamp < 0 ? 'MANUAL_ASSIGNMENT.start_recording': 'MANUAL_ASSIGNMENT.recording') | translate }}
          </span>
          <span class="video-record__status-time">{{timestamp | secondsToTime}}</span>
        </div>
        <button class="video-record__stop-btn" mat-fab aria-label="Stop recording" (click)="stopRecording()" [disabled]="!deviceReady && recordType !== 'screen'">
          <mat-icon>{{paused ? 'circle' : 'stop' }}</mat-icon>
        </button>
        @if (timestamp > 0 && !paused) {
          <button class="video-record__black-btn" mat-fab aria-label="Pause recording" (click)="pauseRecording()">
            <mat-icon>pause</mat-icon>
          </button>
        }
      }
      @default {
        <div class="video-record__status finished">
          <div class="video-record__status-icon">
            <mat-icon>check</mat-icon>
          </div>
          <span class="video-record__status-title">
            {{ (status === statuses.FINISHED ? 'MANUAL_ASSIGNMENT.recorded' : 'MANUAL_ASSIGNMENT.uploaded') | translate }}
          </span>
          @if (timestamp) {
            <span class="video-record__status-time">{{timestamp | secondsToTime}}</span>
          }
        </div>
        <!-- <button class="video-record__start-btn" mat-fab>
        <mat-icon>check</mat-icon>
      </button> -->
      <button class="video-record__black-btn" mat-fab aria-label="Reset recording" (click)="resetPlayer()">
        <mat-icon>delete</mat-icon>
      </button>
    }
  }
</div>
<div class="video-record__max-duration d-flex align-items-center justify-content-center">
  <span>{{'MANUAL_ASSIGNMENT.max_duration' | translate }}: {{maxVideoLength | secondsToTime}}</span>
</div>
</div>
